import React, { PropTypes, Component } from 'react';
import { isEmpty } from 'lodash';
import cn from 'classnames';

import { convertFileToImage, adjustImageStyling, resetImageStyle } from './profile_image_helper';

import TextInput from 'patternity/lib/text_input';
import SelectDropdown from 'patternity/lib/select_dropdown';
import Form, { Column, Row } from 'patternity/lib/form';
import InputLabel from 'patternity/lib/input_label'
import Button from 'patternity/lib/button2';
import SaveButton from 'patternity/lib/save-button';
import { withNamespaces } from 'react-i18next';

import classes from '!!style-loader!css-loader?modules!./profile_form.css';

class ProfileForm extends Component {
  static propTypes = {
    onProfileChange: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    continueStatus: PropTypes.string.isRequired,
    onUpdateHandler: PropTypes.func.isRequired,
    onCloseDialog: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    supportedLanguages: PropTypes.array
  }

  state = {
    showActionList: false,
    missingImageIcon: true
  };

  componentDidUpdate() {
    const isMissingImageIcon = !this.props.profile.avatar_url ||
      this.props.profile.avatar_url.includes('missing.png');
      this.props.profile.avatar_url.includes('avatar_missing/');

    if (this.state.missingImageIcon !== isMissingImageIcon) {
      this.setState({
        ...this.state,
        missingImageIcon: isMissingImageIcon,
      });
    };
  }

  render() {
    return (
      <div style={styles.profile} onClick={this._clickedOutside}>
        <div style={{overflow: 'hidden'}}>
          <Form>
            <Row>
                {this._imageUpload()}
            </Row>
            <div className={cn(classes.onboardingProfileForm, 'c-onboarding-profile-form')}>
              <div className="c-name">
                <Row>
                  <InputLabel label={this.props.t('Full Name')} layout="stacked">
                    <TextInput
                      name="name"
                      value={this.props.profile.name || ""}
                      onChange={this.props.onProfileChange}
                      error={!isEmpty(this.props.errors.name)}
                      message={this.props.errors.name || " "}
                      required={true} />
                  </InputLabel>
                </Row>
              </div>
              <div className="c-title">
                <Row>
                  <InputLabel label={this.props.t('Job Title')} layout="stacked">
                    <TextInput
                      name="title"
                      value={this.props.profile.title || ""}
                      onChange={this.props.onProfileChange}
                      error={!isEmpty(this.props.errors.title)}
                      message={this.props.errors.title || " "} />
                  </InputLabel>
                </Row>
              </div>
              <div className="c-company">
                <Row className="c-company">
                  <InputLabel label={this.props.t('Company')} layout="stacked">
                    <TextInput
                      name="company"
                      className="c-company"
                      value={this.props.profile.company || ""}
                      onChange={this.props.onProfileChange}
                      error={!isEmpty(this.props.errors.company)}
                      message={this.props.errors.company || " "} />
                  </InputLabel>
                </Row>
              </div>
              {this.props.supportedLanguages &&
                <div className="c-languages">
                  <Row>
                    <InputLabel label={this.props.t('Language')} layout="stacked">
                      <SelectDropdown
                        name="lang"
                        onChange={this.props.onProfileChange}
                        value={this.props.profile.lang}>
                        {this.props.supportedLanguages.map(languageOption => {
                          const name = languageOption[0];
                          const isoCode = languageOption[1];

                          return (
                            <option value={isoCode} key={isoCode}>
                              {name}
                            </option>
                          );
                        })}
                      </SelectDropdown>
                    </InputLabel>
                  </Row>
                </div>
              }
            </div>
          </Form>
        </div>
        <div style={styles.profileActions}>
          <span className={'standard-onboarding-profile-collection-continue-btn'}>
            <SaveButton
              saveStatus={this.props.continueStatus}
              type='primary'
              onClick={this.props.onUpdateHandler}
              customText={saveButtonText(this.props.t)}>
                {this.props.t('Continue')}
            </SaveButton>
          </span>
        </div>

        <div style={styles.profileActions}>
          <Button
            type='text'
            onClick={this.props.onCloseDialog}
            classList={['standard-onboarding-profile-collection-skip-link']}>
            {this.props.t('Skip for now')}
          </Button>
        </div>
      </div>
    );
  }

  _uploadImage = (event) => {
    app.filepicker.pick(response => {
      resetImageStyle(this.refs.profileImage.style, styles.profileImage);
      adjustImageStyling(this.refs.profileImage);
      this.refs.profileImage.src = response.url;
      this._updateProfileImage(response.url);
      this.setState({
        missingImageIcon: false,
        showActionList: false
      });
    }, undefined, false);
  }

  _updateProfileImage = (src) => {
    this.props.onProfileChange({
      target: {
        name: 'avatar_url',
        value: src
      }
    });
    this.props.onProfileChange({
      target: {
        name: 'remove_image',
        value: null
      }
    });
  }

  _clickedOutside = (event) => {
    if(!event.target.classList.contains("keepOptions")) {
      this.setState({
        showActionList: false
      });
    }
  }

  _actionListToggle=() => {
    this.state.missingImageIcon
      ? this._uploadImage()
      : this.setState({
          showActionList: !this.state.showActionList
        })
  }

  _removeImage = () => {
    this.props.onProfileChange({
      target: {
        name: 'avatar_url',
        value: null
      }
    });
    this.props.onProfileChange({
      target: {
        name: 'remove_image',
        value: 't'
      }
    });
    this.refs.profileImage.src = '';
    this.setState({
      missingImageIcon: true,
      showActionList: false
    });
  }

  _imageUpload = () => {
    const removeOptionStyle =
      this.state.missingImageIcon
      ? { opacity:'0.3', cursor: 'not-allowed' }
      : { opacity:'1', cursor: 'pointer' }

    return (
      <div style={styles.imageContainer}>
        <div style={{...styles.profileImageContainer, backgroundColor: '#e8e8e061'}} className="profilePicture">
          <div ref="missingImageIcon" className="missing-image-icon" style={{ display: this.state.missingImageIcon ? '':'none'}} />
          <img ref="profileImage" className="image-tag" style={{...styles.profileImage, display: this.state.missingImageIcon ? 'none':''}} src={this.props.profile.avatar_url} alt="profile picture" />
          <div id="actionListHandler" className="keepOptions" alt="profile picture" style={styles.profileImageActionHandler} onClick={this._actionListToggle}>
            <div className="actionListHandlerIcon keepOptions" />
          </div>
          <div className="welcome_image_action_selector" id="welcome_image_action_selector" ref='actionList' style = {{display: this.state.showActionList ? 'block' : 'none' }}>
            <table style={styles.actionOptions}>
              <tbody>
                <tr id="action_option_1" onClick={this._uploadImage}>
                  <td>{this.props.t("Upload a photo")}</td>
                </tr>
                <tr id="action_option_2" onClick={this._removeImage} className="keepOptions" style={removeOptionStyle}>
                  <td className="keepOptions">{this.props.t("Remove profile photo")}</td>
                </tr>
              </tbody>
            </table>
            <div className="arrow_style">
              <svg className="arrow_inner_style">
                <line x1="0" y1="12" x2="13" y2="0" style={styles.arrowStyle}></line>
                <line x1="13" y1="0" x2="26" y2="12" style={styles.arrowStyle}></line>
                <polygon points="13,1 25,12 1,12"></polygon>
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const saveButtonText = t => ({
  unsaved: t('Continue'),
  saved:   t('Profile Updated'),
  saving:  t('Updating Profile'),
  error:   t('Error')
});

const styles = {
  profile: {
    width: '80%',
    overflow: 'hidden',
    margin: '20px auto',
  },
  profileActions: {
    textAlign: 'center',
    margin: '10px'
  },
  profileImageContainer: {
    borderRadius: '100%',
    verticalAlign: 'middle',
    width: '160px',
    height: '160px',
    display: 'inline-block',
    overflow: 'hidden'
  },
  profileImage: {
    height: '160px',
    width: '160px',
    position: 'relative'
  },
  imageContainer: {
    textAlign: 'center'
  },
  uploadAction: {
    verticalAlign: 'middle',
    display: 'inline-block'
  },
  profileImageActionHandler: {
    position: 'absolute',
    height: '40px',
    width: '40px' ,
    borderRadius: '50%',
    top: '33%',
    left: '54%',
    zIndex: '999'
  },
  actionOptions: {
    height: '100%',
    width: '100%'
  },
  arrowStyle: {
    stroke: 'rgba(200, 200, 200, 0.1)',
    strokeWidth: '1'
  }
}

export default withNamespaces()(ProfileForm);



// WEBPACK FOOTER //
// ./src/advocate/onboarding/components/profile_form.js